import React from "react";
import { Container, Grid, Typography, Box, Card, Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";


// Importing Images
import heroBg from "../assets/heroBg.jpeg";
import heroBg1 from "../assets/heroBg1.jpeg";
import image from "../assets/image.png";
import image2 from "../assets/image2.png.jpg";

// Services Data
const services = [
  { title: "Custom Software", img: heroBg },
  { title: "AI & Automation", img: heroBg1 },
  { title: "AR/VR Applications", img: image },
  { title: "UI/UX Design", img: image2 },
];

// Testimonials Data
const testimonials = [
  {
    name: "John Doe",
    feedback:
      "Willovate transformed our business with a cutting-edge AI system!",
    img: "/assets/user1.jpg",
  },
  {
    name: "Emily Smith",
    feedback:
      "The team delivered a custom web app that exceeded our expectations!",
    img: "/assets/user2.jpg",
  },
];

// Styled Button
const GradientButton = styled("button")({
  marginTop: "30px",
  padding: "15px 40px",
  fontSize: "1.1rem",
  fontWeight: "bold",
  color: "#fff",
  background: "linear-gradient(90deg, #84F4EE, #2DEB9C)",
  border: "none",
  borderRadius: "40px",
  cursor: "pointer",
  transition: "transform 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.08)",
    boxShadow: "0px 10px 20px rgba(0,0,0,0.2)",
  },
});

const ExploreMore = () => {
  const navigate = useNavigate();

  return (
    <Box>
      {/* Hero Section with Background Image */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: { xs: "220px", md: "100px" },
          textAlign: "center",
          overflow: "hidden",
          mt: { xs: 7, md: 8 },
        }}
      >
        {/* Background Image */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            transform: "translate(-50%, -50%)",
            width: "100%",
            height: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            filter: "brightness(50%)",
            zIndex: -1,
          }}
        />

        {/* Text Content */}
        <Typography
          variant="h2"
          fontWeight="bold"
          sx={{ color: "#000ca4", zIndex: 1 }}
        >
          You Think It, We Build It
        </Typography>

      </Box>
      {/* Services Section */}
      <Container
        width="100%"
        maxWidth="100%"
        sx={{ textAlign: "center", backgroundColor: "#fff", py: 10 }}
      >
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="stretch"
        >
          {services.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(45, 92, 235, 0.58)",
                  textAlign: "center",
                  transition: "0.3s",
                  height: "100%",
                  border: "1px solid #e0e0e0",
                  minHeight: "340px", // Adjust card height
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 6px 18px rgb(45, 235, 156, 0.9)",
                    border: "1px solid #2DEB9C",
                  },
                }}
              >
                {/* Image Box with Centered Title */}
                <Box
                  sx={{
                    position: "relative",
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  <Box
                    component="img"
                    src={item.img}
                    alt={item.title}
                    sx={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "10px 10px 0 0",
                    }}
                  />

                  <Typography
                    variant="h5"
                    fontWeight="600"
                    sx={{
                      width: "100%",
                      maxWidth: "400px",
                      mt: 5,
                      px: 0,
                      mb: 2,
                      color: "#333",
                      textAlign: "center",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Testimonials Section */}
      <Box
        sx={{
          background:
            "linear-gradient(to right, rgba(45, 92, 235, 1), rgb(45, 235, 156))",
          py: 12,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            fontWeight="bold"
            textAlign="center"
            mb={5}
            sx={{ color: "#fff" }}
          >
            What Our Clients Say
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {testimonials.map((client, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    padding: "30px",
                    textAlign: "center",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  }}
                >
                  <Avatar
                    src={client.img}
                    sx={{ width: 80, height: 80, margin: "auto" }}
                  />

                  <Typography variant="h5" fontWeight="bold" mt={2} mb={2}>
                    {client.name}
                  </Typography>

                  <Typography variant="body2" color="textSecondary">
                    "{client.feedback}"
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Call to Action */}
      <Box sx={{ textAlign: "center", backgroundColor: "#fff", py: 18 }}>
        <Typography variant="h2" fontWeight="bold" color="black" mb={5}>
          Have an idea? Let’s build it together!
        </Typography>

        <GradientButton onClick={() => navigate("/contact")}>
          Start Your Project
        </GradientButton>
      </Box>
    </Box>
  );
};

export default ExploreMore;
